export default __webpack_public_path__ + "static/media/marker-dark-blue.e91801fd.svg";